import { Text } from '@medly-components/core';
import styled, { css } from 'styled-components';

interface ZoneTileWrapperProps {
    isActive?: boolean;
}

export const ZoneTileTitle = styled(Text)<ZoneTileWrapperProps>`
    font-weight: ${props => (props.isActive ? 400 : 300)};
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const ZoneTileCount = styled(Text)<ZoneTileWrapperProps>`
    border-radius: 1.6rem;
    padding: 0 1rem;
    font-weight: ${props => (props.isActive ? 400 : 300)};
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.darkBlue};

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        padding: 0 0.8rem;
    }
`;

const activeTileStyles = css`
    ${ZoneTileTitle} {
        color: ${({ theme }) => theme.colors.white};
    }

    ${ZoneTileCount} {
        background: white;
        color: ${({ theme }) => theme.colors.darkBlue};
    }
`;

export const ZoneTileWrapper = styled.div<ZoneTileWrapperProps>`
    display: flex;
    min-width: 8.7rem;
    border-radius: 4rem;
    background: ${({ isActive, theme }) => (isActive ? theme.colors.darkBlue : 'none')};
    padding: 0.4rem 1.6rem;
    justify-content: center;
    gap: 0.8rem;
    align-items: center;
    cursor: pointer;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        min-width: 6rem;
        gap: 0.4rem;
        padding: 0.4rem 0.8rem;
    }
    ${({ isActive }) => isActive && activeTileStyles};
`;
